import { useEngine, useStation } from "../game/runtime";
import { t } from "../i18n";
import { PixelText } from "./pixel";
import { Led } from "./primitives";

const SPEEDS = [1, 10, 60];

/** Commandes du bac à sable : accélérer le temps pour voir venir l'usure et les pannes. */
export function SandboxControls() {
  const engine = useEngine();
  useStation();
  if (!engine) return null;
  const speed = engine.getSpeed();
  return (
    <div className="bezel pointer-events-auto">
      <div className="flex items-center gap-1.5">
        <span className="flex items-center gap-2 px-1 text-[0.8125rem] font-semibold uppercase tracking-[0.08em] text-night">
          <Led on blink color="var(--color-night)" />
          {t("sandbox.badge")}
        </span>
        {SPEEDS.map((value) => (
          <button
            key={value}
            type="button"
            onClick={() => engine.setSpeed(value)}
            aria-pressed={speed === value}
            aria-label={t("sandbox.speed", { speed: value })}
            className="key"
            data-size="sm"
          >
            <PixelText text={`×${value}`} label={false} />
          </button>
        ))}
      </div>
    </div>
  );
}

/** En attendant la station : l'écran de la borne s'allume. */
export function BootScreen() {
  return (
    <div className="grid h-full place-items-center" role="status">
      <p className="flex items-center gap-3 text-accent">
        <Led on blink color="var(--color-accent)" />
        <PixelText text={t("app.loading")} scale={2} />
      </p>
    </div>
  );
}
